import ChairContext from "../../../UseContextChairHandlers";
import ColorsChairContext from "../../../useContextColorsChair";

//
import { Suspense, useEffect, useContext } from "react";
import { Canvas } from "@react-three/fiber";

import { Environment, ContactShadows, OrbitControls } from "@react-three/drei";
import Chair from "./Chair";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

const ChairCustom = () => {
  const { ref, inView } = useInView();
  const animDescriptionIconsColorChair = useAnimation();

  useEffect(() => {
    if (inView) {
      animDescriptionIconsColorChair.start({
        y: 0,
        transition: {
          type: "spring",
          duration: 1,
          damping: 13,
          delay: 0.2,
        },
      });
    }

    if (!inView) {
      animDescriptionIconsColorChair.start({
        y: 350,
      });
    }
  }, [inView]);

  const {
    onCrocoTexture,
    handleCrocoTexture,
    onMatFabric,
    handlerMatFabric,
    onGlossyTexture,
    handlerGlossy,
  } = useContext(ChairContext);

  const {
    currentCrocoColor,
    handleColorCrocoChair,
    currentColor,
    handleColorChange,
    currentsColorFont2,
    currentsColorFont,
  } = useContext(ColorsChairContext);

  return (
    <motion.div ref={ref} className="container__chair-Customized">
      <motion.div
        style={{ width: "100%", height: "100%" }}
        animate={animDescriptionIconsColorChair}
      >
        <Canvas
          frameloop="demand"
          gl={{
            antialias: true,
          }}
          id="canvas_custome"
          camera={{ fov: 16.8, position: [10, 0, 1] }}
        >
          <Suspense fallback={null}>
            <OrbitControls
              enablePan={true}
              enableZoom={false}
              enableRotate={true}
              autoRotate={false}
            />
            {onCrocoTexture && (
              <>
                <pointLight
                  color="#ffffff"
                  position={[0, 5, 10]}
                  intensity={24}
                />
                <ambientLight intensity={5.8} position={[0, 1, 0]} />
              </>
            )}

            <pointLight
              color="#ffffff"
              position={[-0.5, 20, 0]}
              intensity={8.5}
            />
            <ambientLight intensity={1.8} position={[0, 1, 0]} />
            <Environment
              background={false}
              files={"studio_small_09_1k.hdr"}
              path={"/chairItems/"}
              preset={null}
              scene={undefined}
              encoding={undefined}
            />
            <group position={[0, -0.9, 0]} rotation={[0, -4.6, 0]}>
              <Chair
                currentCrocoColor={currentCrocoColor}
                onCrocoTexture={onCrocoTexture}
                onMatFabric={onMatFabric}
                onGlossyTexture={onGlossyTexture}
                currentColor={currentColor}
              />

              <ContactShadows
                position={[0, -0.05, 0]}
                scale={10}
                blur={3}
                opacity={0.25}
                far={10}
              />
            </group>
          </Suspense>
        </Canvas>
        <div>
          <MenuColoi
            onCrocoTexture={onCrocoTexture}
            handleColorCrocoChair={handleColorCrocoChair}
            onMatFabric={onMatFabric}
            onGlossyTexture={onGlossyTexture}
            handleCrocoTexture={handleCrocoTexture}
            handlerMatFabric={handlerMatFabric}
            handlerGlossy={handlerGlossy}
            handleColorChange={handleColorChange}
            currentsColorFont={currentsColorFont}
            currentsColorFont2={currentsColorFont2}
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

const MenuColoi = () => {
  return;
};

export default ChairCustom;
